import React, { useContext } from 'react'
import { Projects } from '../data/project';
import { motion } from 'framer-motion';
import Tilt from 'react-parallax-tilt';
import { FiFigma, FiEye } from 'react-icons/fi';
import { ImGithub } from 'react-icons/im';
import { useTranslation } from 'react-i18next';
import {Link} from 'react-router-dom';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay } from "swiper";
import { themeContext } from '../context/Theme';
import withScrollReveal from '../animattion/withScrollReveal';





const Portfolio = () => {

  const { dark } = useContext(themeContext);
  const { t } = useTranslation();

  return (
    <div id='Portfolio' className='h-auto w-full md:pt-10'>
      <p className='text-center text-[2rem] font-bold'>{t('Projects')}</p>
      <div className='py-6 flex flex-col flex-wrap gap-4 '>
        {/* single project holder */}
        {
          Projects.map((projectData) => (
            
            <Tilt key={projectData.id} className={` h-auto w-full md:flex md:flex-wrap hover:shadow-2xl hover:shadow-blue z-10 border-2 border-black ${dark ? 'bg-dark_gray ' : 'bg-gray-200 hover:shadow-black'} `}>

              <Swiper
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                className="h-[16rem] w-full lg:w-[40%] lg:h-[inherit]"
              >

                {projectData.image1 && ( // Check if image1 exists
                  <SwiperSlide >
                    <img src={projectData.image1} alt={projectData.title} className='h-full  w-full object-fill object-center' />
                  </SwiperSlide>
                )}
                {projectData.image2 && ( // Check if image1 exists
                  <SwiperSlide>
                    <img src={projectData.image2} alt={projectData.title} className='h-full w-full object-fill object-center' />
                  </SwiperSlide>
                )}
                {projectData.image3 && ( // Check if image1 exists
                  <SwiperSlide>
                    <img src={projectData.image3} alt={projectData.title} className='h-full w-full object-fill object-center' />
                  </SwiperSlide>
                )}
                {projectData.image4 && ( // Check if image1 exists
                  <SwiperSlide>
                    <img src={projectData.image4} alt={projectData.title} className='h-full w-full object-fill object-center' />
                  </SwiperSlide>
                )}
              </Swiper>

              <div className='h-auto p-4 flex flex-col justify-between items-center lg:w-[60%] lg:items-start lg:p-2'>

                <div className="lg:pl-2">
                  <p className='pt-4 text-2xl font-bold text-center lg:text-left lg:pt-2 '>
                    {t(projectData.translationKey + '.title')}
                  </p>
                  <p className='pt-2 text-base text-justify'>
                  <p className='inline font-bold text-base'>Tech: </p>{ t(projectData.translationKey + '.tech')}
                  </p>
                  <p className='pt-2 text-xl font-light pb-4 text-justify'>
                    {t(projectData.translationKey + '.desc')}
                  </p>
                </div>
                <div className="flex flex-wrap gap-4 pb-2 lg:pl-2">

                  <Link to={projectData.figma} title='figma design' target='_blank'
                  className={projectData.figma !== "" ? 'inline' : 'hidden'}>
                    <motion.div
                      whileHover={{ scale: 1.2 }}
                    >
                      <FiFigma className={`h-[1.8rem] w-[1.8rem] cursor-pointer ${dark ? 'text-white' : 'text-black'}`} />
                    </motion.div>
                  </Link>

                  <Link to={projectData.github} title='source code' target='_blank'
                  className={projectData.github !== "" ? 'inline' : 'hidden'}>
                    <motion.div
                      whileHover={{ scale: 1.2 }}
                    >
                      <ImGithub className={`h-[1.8rem] w-[1.8rem] cursor-pointer ${dark ? 'text-white' : 'text-black'}`} />
                    </motion.div>
                  </Link>
                  <Link to={projectData.link} title='preview' target='_blank'
                  className={projectData.link !== "" ? 'inline' : 'hidden'}>
                    <motion.div
                      whileHover={{ scale: 1.2 }}
                    >
                      <FiEye className={`h-[1.8rem] w-[1.8rem] cursor-pointer ${dark ? 'text-white' : 'text-black'}`} />
                    </motion.div>
                  </Link>

                </div>
              </div>
            </Tilt>
          ))
        }

      </div>
    </div>
  )
}

export default withScrollReveal(Portfolio);